import styled from 'styled-components';

import { baseLinkCss } from './styled';
import { HoverTheme, IHover } from './types';

export const AddNewCardLink = styled.button<IHover>`
  ${baseLinkCss}
  text-align: left;
  padding: 0 0 0 0.8rem;
  color: ${p => (p.hoverTheme === HoverTheme.DARK ? Styles.color.white : '#000')};
  font-size: 0.875rem;
  font-family: ${Styles.fontFamily.body};

  &:hover {
    background-color: ${Styles.color.primary};
    color: ${p => (p.hoverTheme === HoverTheme.DARK ? 'inherit' : Styles.color.white)};
  }
`;
